<template>
    <div class="lang-switch">
        <button type="button" :class="['lang-flag', { active: language === 'hr' }]"
                :title="$t('croatian')" :aria-label="$t('croatian')" @click="change('hr')">
            <!-- Croatia: red / white / blue tricolour with a simplified checkerboard shield -->
            <svg viewBox="0 0 60 40" preserveAspectRatio="none" aria-hidden="true">
                <rect width="60" height="13.34" fill="#ff0000" />
                <rect y="13.34" width="60" height="13.33" fill="#ffffff" />
                <rect y="26.67" width="60" height="13.33" fill="#171796" />
                <g>
                    <rect x="24" y="12" width="12" height="16" fill="#ffffff" />
                    <rect x="24" y="12" width="3" height="4" fill="#ff0000" />
                    <rect x="30" y="12" width="3" height="4" fill="#ff0000" />
                    <rect x="27" y="16" width="3" height="4" fill="#ff0000" />
                    <rect x="33" y="16" width="3" height="4" fill="#ff0000" />
                    <rect x="24" y="20" width="3" height="4" fill="#ff0000" />
                    <rect x="30" y="20" width="3" height="4" fill="#ff0000" />
                    <rect x="27" y="24" width="3" height="4" fill="#ff0000" />
                    <rect x="33" y="24" width="3" height="4" fill="#ff0000" />
                </g>
            </svg>
        </button>
        <button type="button" :class="['lang-flag', { active: language === 'en' }]"
                :title="$t('english')" :aria-label="$t('english')" @click="change('en')">
            <!-- United Kingdom (simplified Union Jack) -->
            <svg viewBox="0 0 60 40" preserveAspectRatio="none" aria-hidden="true">
                <rect width="60" height="40" fill="#012169" />
                <path d="M0,0 L60,40 M60,0 L0,40" stroke="#ffffff" stroke-width="8" />
                <path d="M0,0 L60,40 M60,0 L0,40" stroke="#c8102e" stroke-width="4" />
                <path d="M30,0 V40 M0,20 H60" stroke="#ffffff" stroke-width="13" />
                <path d="M30,0 V40 M0,20 H60" stroke="#c8102e" stroke-width="7" />
            </svg>
        </button>
    </div>
</template>

<script>
import { applyLanguage } from '@/plugins/lang.js';

export default {
    name: 'LanguageSwitcher',
    computed: {
        language() {
            return this.$store.state.language;
        }
    },
    methods: {
        change(language) {
            if (this.language === language) return;
            applyLanguage(language);
            // Remember the choice for this person once they are signed in.
            if (this.$store.getters.isAuthenticated) {
                this.$api.post('language', { language }, { client: false, loader: false });
            }
        }
    }
};
</script>
